import {DateService} from "../services/date.service";


export class DateWithoutTime{

    private date: string;

    public constructor(date: string | Date) {
        this.date = DateService.getIsoDate(date);
    }

    public isBefore(date: string | Date): boolean
    {
        return DateService.compareDateWithoutTime(this.date, date) <= 0;
    }

    public isStrictlyBefore(date: string | Date): boolean
    {
        return DateService.compareDateWithoutTime(this.date, date) < 0;
    }

    public isAfter(date: string | Date): boolean
    {
        return DateService.compareDateWithoutTime(this.date, date)  >= 0;
    }

    public isStrictlyAfter(date: string | Date): boolean
    {
        return DateService.compareDateWithoutTime(this.date, date)  > 0;
    }
}
